const PaymentLogoVisa = () => (
  <svg width="30" height="18" viewBox="0 0 30 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7695 0C25.7627 0 29.8105 3.99985 29.8105 8.93359C29.8104 13.8672 25.7626 17.8662 20.7695 17.8662C18.5311 17.8662 16.4842 17.061 14.9053 15.7295C13.3264 17.061 11.2795 17.8662 9.04102 17.8662C4.04794 17.8662 0.000142922 13.8672 0 8.93359C0 3.99985 4.04785 0 9.04102 0C11.2794 2.32863e-05 13.3264 0.80536 14.9053 2.13672C16.4841 0.805355 18.5312 3.60719e-05 20.7695 0Z"
      fillOpacity="0.8"
    />
    <path
      d="M20.7695 0C25.7627 0 29.8105 3.99985 29.8105 8.93359C29.8104 13.8672 25.7626 17.8662 20.7695 17.8662C18.5311 17.8662 16.4842 17.061 14.9053 15.7295C16.8482 14.091 18.082 11.6554 18.082 8.93359C18.082 6.2116 16.8484 3.77525 14.9053 2.13672C16.4842 0.805358 18.5312 2.96795e-05 20.7695 0Z"
      fillOpacity="0.5"
    />
    <path
      d="M14.9043 2.13721C16.8475 3.77566 18.0809 6.21116 18.0811 8.93311C18.0811 11.655 16.8474 14.0905 14.9043 15.729C12.9617 14.0905 11.7285 11.6546 11.7285 8.93311C11.7286 6.21155 12.9616 3.77565 14.9043 2.13721Z"
      fillOpacity="0.8"
    />
  </svg>
);

export default PaymentLogoVisa;
